import { useEffect } from "react";
import Header from "@/components/Header";
import InstructorSection from "@/components/InstructorSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import Footer from "@/components/Footer";

const AboutPage = () => {
  useEffect(() => {
    const previousTitle = document.title;
    const description = document.querySelector('meta[name="description"]');
    const previousDescription = description?.getAttribute("content");
    document.title = "About Our Instructor | MyEnglish Lesson.ca";
    description?.setAttribute("content", "Meet Tammam Mahdi, a certified Canadian ESL instructor helping newcomers build practical speaking confidence for work and daily life.");
    return () => { document.title = previousTitle; if (description && previousDescription) description.setAttribute("content", previousDescription); };
  }, []);

  const goToBookings = () => { window.location.href = "/#booking-section"; };

  return <div className="site-shell" id="about-page-top"><Header homePrefix="/" onBook={goToBookings} /><main id="main-content"><InstructorSection /><TestimonialsSection /></main><Footer homePrefix="/" /></div>;
};

export default AboutPage;
